import { Mail } from "lucide-react";
import { appConfig } from "@/config/app";
import { BRAND } from "../brand";
import { Reveal } from "../motion/Reveal";

const CONTACT = appConfig.contactEmail;

/** Origine du produit : une note éditoriale sobre, sans accessoires de papeterie. */
export function FounderNote() {
  return (
    <section aria-labelledby="mot-equipe" className="py-20 lg:py-28">
      <div className="mx-auto max-w-[860px] px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div
            className="rounded-panel border border-border bg-surface px-6 py-9 sm:px-12"
          >
            <p className="text-xs font-semibold tracking-[0.16em] text-action uppercase">
              Le mot de l’équipe
            </p>
            <h2
              id="mot-equipe"
              className="mt-4 font-display text-[clamp(1.6rem,3vw,2.3rem)] leading-[1.15] font-semibold tracking-[-0.012em] text-foreground text-balance"
            >
              Nous avons perdu des notes d’appel à chaque avoir. Alors nous avons
              construit l’outil qui les garde.
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground">
              <p>
                {BRAND} est né dans une entreprise B2B française qui courait après ses
                paiements en retard. Au moindre relettrage, le contexte des clients
                partait avec la facture.
              </p>
              <p>
                {BRAND} est la couche qui manquait&nbsp;: il garde le fil de chaque client, et
                il laisse la décision à celle ou celui qui relance. Édité en France, par
                une entreprise indépendante.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-border pt-6">
              <p className="text-sm font-semibold text-foreground">L’équipe {BRAND}</p>
              <a
                href={`mailto:${CONTACT}`}
                className="inline-flex min-h-11 cursor-pointer items-center gap-2 rounded-lg px-1 text-sm font-semibold text-action hover:text-action-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
              >
                <Mail aria-hidden className="size-4" />
                {CONTACT}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
